module.exports = {
	"common": {
		"nextButton": {
			"labelText": "Next"
		},
		"continueButton": {
			"labelText": "Continue"
		},
		"closeButton": {
			"labelText": "Close"
		}
	},
	"error": {
		"general": {
			"message": "An error occurred"
		},
		"notFound": {
			"message": "Page not found"
		},
		"nothingToSign": {
			"message": "Nothing to sign"
		},
		"field": {
			"minNotMetMessage": "Please select at least {min} { min, plural, =1 {item} other {items} }",
			"maxExceededMessage": "You have selected too many boxes. Please uncheck one.",
			"requiredMessage": "This field is required",
			"fieldsMissing": "Required fields are missing. Please click 'Edit'."
		},
		"network": {
			"title": "Your connection has been lost.",
			"message": "Please wait until your connection is reestablished to continue."
		},
		"noValidSignatureTypes": {
			"title": "Can't sign on mobile",
			"message": "Warning: This document can only be completed from a computer due to the settings set by the person that sent you this document."
		},
		"validation": {
			"numbers_only": "This field only accepts numbers",
			"letters_only": "This field only accepts letters",
			"phone_number": "Please enter a 10- or 11-digit telephone number",
			"bank_routing_number": "Please enter a 9-digit routing number",
			"bank_account_number": "Please enter a minimum of 6 digits",
			"email_address": "Please enter a valid email address",
			"zip_code": "Please enter a 5- or 9-digit zip code",
			"social_security_number": "Please enter a 9-digit social security number",
			"employer_identification_number": "Please enter a 9-digit employer identification number"
		},
		"accountSignup": {
			"existingAccount": "That account already exists!"
		}
	},
	"signer": {
		"choice": {
			"message": {
				"welcomeText": "Hi {emailAddress},",
				"instructionsText": "More than one person has been associated with your email address, please identify yourself and click &quot;continue&quot;."
			},
			"continueButton": {
				"labelText": "Continue"
			}
		},
		"document": {
			"alert": {
				"insertedInAllFieldsMessage": "Your { type, select, signature {signature has} initials {initials have} } been inserted everywhere",
				"testRequestMessage": "This is a mock signature request and it has no legal value",
				"allRequiredFieldsCompleted": "{ isDesktop, select, 1 {You have completed all required fields. Please click 'Continue'.} 0 {Required fields are done. Tap 'Continue'.} }"
			},
			"signature": {
				"insertEverywhereLabelText": "Insert everywhere",
				"editLabelText": "Edit",
				"clearLabelText": "Clear"
			},
			"loader": {
				"text": "Preparing document",
				"finalizing": "We&apos;re finalizing your document"
			}
		},
		"field": {
			"label": {
				"mobileText": "{ type, select, signature {Signature} initials {Initials} text {} date {} }",
				"desktopText": "{ type, select, signature {Click to sign} initials {Click to initial} text {} date {} }"
			},
			"groupMinReqText": "At least {min} { min, plural, =1 {checkbox is} other {checkboxes are} } required",
			"groupMinMaxReqText": "{min} to {max} { max, plural, =1 {checkbox} other {checkboxes} } can be selected",
			"groupMaxReqText": "At most {max} checkboxes can be selected",
			"groupSameMinMaxReqText": "{min} { min, plural, =1 {checkbox} other {checkboxes} } must be selected"
		},
		"nav": {
			"fieldsLeftMessage": "REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>",
			"fieldsLeftMiniMessage": "REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>",
			"nextReqMessage": "Next Req*",
			"nextMessage": "Next"
		},
		"download": {
			"tooltip": {
				"text": "Download file"
			}
		},
		"headerMenu": {
			"download": "Download",
			"decline": "Decline",
			"close": "Close",
			"delegate": "Reassign"
		},
		"subheader": {
			"delegate": {
				"message": "Not the authorized signer?",
				"ctaMessage": "Assign to someone else"
			}
		},
		"enterCode": {
			"title": "Please enter access code to view",
			"note": "Note: the access code is case sensitive.",
			"checkingText": "Checking...",
			"error": {
				"incorrectText": "The access code you've entered is incorrect. {attemptsRemaining} {attemptsRemaining, plural, =1 {attempt} other {attempts}} remaining.",
				"maxAttemptsText": "You have reached the maximum number of attempts."
			}
		},
		"preview": {
			"title": "Please fill out & sign this document.",
			"desktopHeaderInfoMessage": {
				"siteUi": "Hello {name},<br />Click 'Get Started' to fill out and sign '<strong>{title}</strong>', or <a href='{downloadLink}'>download</a> the original.",
				"embedded": "Hello {name},<br />Click 'Get Started' to fill out and sign '<strong>{title}</strong>'."
			},
			"getStartedButton": {
				"labelText": "Get Started"
			}
		},
		"confirm": {
			"title": "Almost done.",
			"legalMessage1": "I agree to be legally bound by this document and the <a href='https://www.hellosign.com/info/tos' class='whitelabel-link' target='_blank' rel='noopener noreferrer'>HelloSign Terms of Service</a>. Click on 'I Agree' to sign this document.",
			"legalMessage2": "Almost done. By clicking \"I Agree\" you are legally signing this document and agreeing to the <a href='https://www.hellosign.com/info/tos' class='whitelabel-link' target='_blank' rel='noopener noreferrer'>eSignature Terms of Service</a>.",
			"agreeButton": {
				"labelText": "I agree"
			},
			"backButton": {
				"labelText": "back",
				"desktopText": "Edit"
			}
		},
		"decline": {
			"modal": {
				"title": "Decline to sign this document",
				"description": "Declining this document will clear anything you have entered and notify the sender.",
				"reasonTitle": "Reason for declining",
				"sharedOnlyWithSender": "This information will be shared only with the sender.",
				"declineButton": "Decline",
				"cancelButton": "Cancel",
				"noReasonError": "Please provide a reason."
			},
			"complete": {
				"documentClosed": "This document is now closed.",
				"emailConfirmation": "You'll receive an email confirmation shortly."
			}
		},
		"delegate": {
			"modal": {
				"title": "Reassign this document",
				"description": "If you’re not the authorized signer for this document, you can assign it to someone else. By reassigning, the document will be cleared of anything you have entered.",
				"reasonTitle": "Reason for reassigning",
				"sharedOnlyWithSender": "This information will only be shared with the requester and the recipient.",
				"confirmButton": "Reassign",
				"cancelButton": "Cancel",
				"name": "Name",
				"email": "Email",
				"noReasonError": "Please provide a reason.",
				"noEmailError": "Please provide an email.",
				"noNameError": "Please provide a name.",
				"ctaMessage": "In completing this step, the requester and the recipient will receive a notification of the changes.  You will no longer have access to sign this document and you will receive a copy of the completed document once all parties have signed."
			},
			"complete": {
				"documentDelegated": "This document has now been reassigned to {newSignerName}",
				"emailConfirmation": "You'll receive a confirmation email shortly."
			}
		},
		"complete": {
			"thanksMessage": "Thanks for submitting your document!",
			"willReceiveCopyMessage": "You'll receive a copy in your inbox shortly.",
			"aboutHelloSignMessage": "Need someone to sign a document? <br /> Send it with HelloSign.",
			"takeTourButton": {
				"labelText": "Learn More"
			},
			"inPerson": {
				"thanks": "Thanks for signing this document!",
				"farewell": "Have a fantastic day.",
				"signAgain": "Start Another Signature Process"
			},
			"convertSigners": {
				"header": "Thanks for submitting your document. You'll receive a copy in your inbox shortly.",
				"title": "Fundraising is hard. Make agreements easy.",
				"subtitle": {
					"preLink": "With HelloSign, founders get",
					"link": "3 free",
					"postLink": "documents per month."
				},
				"signupForm": {
					"text": "Activate Your Free Account",
					"placeholder": "Enter your email",
					"optInLabel": "Send me HelloSign updates",
					"buttonText": "Submit",
					"successTitle": "Success!",
					"successText": "Please check your email for the confirmation link."
				},
				"apiMessage": "Integrate eSignatures into your website or workflow within hours.",
				"apiButtonText": "Learn about our API"
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/translations/en-US.json
 ** module id = 759
 ** module chunks = 0 1
 **/